import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-garage-developer-guide/ibm-garage-developer-guide/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Globals from 'gatsby-theme-carbon/src/templates/Globals';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Provides the steps to set up the terminal shell to perform the Workshop hands on labs.`}</p>
    </PageDescription>
    <h2>{`Configure Terminal Shell`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`You can use `}<a parentName="p" {...{
            "href": "https://cloud.ibm.com/shell"
          }}>{`IBM Cloud Shell`}</a>{`, the `}<a parentName="p" {...{
            "href": "https://developer.ibm.com/openlabs/openshift"
          }}>{`OpenLabs Shell`}</a>{` or your local workstation. More details in `}<a parentName="p" {...{
            "href": "https://cloudnativetoolkit.dev/getting-started/dev-env-setup"
          }}>{`Toolkit Dev Setup`}</a>{` and `}<a parentName="p" {...{
            "href": "https://cloudnativetoolkit.dev/getting-started/cli"
          }}>{`Toolkit CLI`}</a>{`.
Run the following command on Cloud, Linux or MacOS shell:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -sL shell.cloudnativetoolkit.dev | bash -
source ~/.bashrc || source ~/.zshrc

`}</code></pre>
        <p parentName="li">{`  Be sure to follow the instructions provided to enable the changes in the current terminal session.`}</p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      